import { Dialog } from "primereact/dialog";
import { JVDropdown } from "../../shared/JVDropdown";
import { InputTextarea } from "primereact/inputtextarea";
import { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { Fetch } from "../../shared/Fetch";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Card } from "primereact/card";

interface IProps {
    open: boolean,
    singleData: any,
    onClose: () => void,
    toast: any
}

interface IClauseCommet {
    id?: number,
    clause_ID?: number,
    sub_Clause_ID?: number,
    comment?: string,
    document_ID?: number,
}

const schema = yup.object({
    clause_ID: yup.number().required("Clause is required"),
    sub_Clause_ID: yup.number().required("Sub Clause is required").min(1),
    comment: yup.string().nullable(),
    document_ID: yup.string().nullable(),
});

export const LeagleComments = (props: IProps) => {
    const [calusesList, setCalusesList] = useState<Array<IClauseCommet>>([]);
    const [loading, setLoading] = useState(false);
    const [loading1, setLoading1] = useState(false);
    const [values, setValues] = useState<string>('');
    const [caluseNameList, setCaluseNameList] = useState<Array<any>>([]);
    const [subCaluseList, setSubCaluseList] = useState<Array<any>>([]);
    const [openCommentDialog, setOpenCommentDialog] = useState({ open: false, singleData: {} } as { open: boolean, singleData: any })

    const { control, handleSubmit, formState: { errors }, reset, setValue, watch } = useForm<IClauseCommet>({
        resolver: yupResolver(schema),
        defaultValues: {},
        shouldFocusError: false
    });

    const onHide = () => {
        reset({
            clause_ID: 0,
            sub_Clause_ID: 0,
            comment: "",
            document_ID: 0
        });
        setValues("");
        props.onClose();
    };

    const onSubmit = async (data: IClauseCommet) => {
        if (values.trim() === "") {
            props.toast.current.show({ severity: 'error', detail: 'Please Give Some Comment', life: 3000 });
        } else {
            setLoading(true);

            let newData = { ...data, comment: values, document_ID: Number(props.singleData.document_ID) };

            const response = await Fetch(("vwPODetails" + ((newData.id !== null && newData.id !== undefined && newData.id > 0) ? "/updateLeagalClausesComment" : "/addLeagalClausesComment")), (newData.id !== null && newData.id !== undefined && newData.id > 0) ? "PUT" : "POST", newData, null, props.toast);
            if (response) {
                reset({
                    clause_ID: 0,
                    sub_Clause_ID: 0,
                    comment: "",
                    document_ID: 0
                });
                setValues("");
                loadClauses();
                setLoading(false);
            } else setLoading(false);
        }

    }

    const loadClauses = async () => {
        setLoading1(true);
        const response = await Fetch("vwPODetails/getLeagalClausesComment", "GET", null, `document_ID=${props.singleData.document_ID}`, props.toast);
        if (response) {
            const data = await response.json();
            setCalusesList(data);
            setLoading1(false);
        } else setLoading1(false);
    }

    const loadClausesname = async () => {
        const response = await Fetch("Dropdown/getClause", "GET", null, null, props.toast);
        if (response) {
            const data = await response.json();
            setCaluseNameList(data);
        }
    }

    const loadSubClausesname = async (clause_ID: number) => {
        const response = await Fetch("Dropdown/getSubClause", "GET", null, `clauseID=${clause_ID}`, props.toast);
        if (response) {
            const data = await response.json();
            setSubCaluseList(data);
        }
    }

    const removeComment = async (rowData: any) => {
        const response = await Fetch("vwPODetails/removeLeagalClausesComment", "DELETE", null, `docID=${rowData.id}`, props.toast);
        if (response) {
            reset({
                clause_ID: 0,
                sub_Clause_ID: 0,
                comment: "",
                document_ID: 0
            });
            setValues("");
            loadClauses();
            setLoading(false);
        } else setLoading(false);
    }


    const confirmDelete = (rowData: any) => {
        confirmDialog({
            message: `Are you sure you want to Delete Comment`,
            header: 'Confirm ',
            icon: 'pi pi-exclamation-triangle',
            // defaultFocus: 'reject',
            acceptClassName: 'p-button-danger',
            accept: () => removeComment(rowData),
            reject: () => () => { }
        });
    }

    const actionBodyTemplate = (rowData: any) => {
        return <div style={{ display: 'flex' }}>
            <Button icon="pi pi-pencil" className="p-button-rounded  p-button-text" tooltip="Edit Clause Comment" onClick={() => {
                loadSubClausesname(rowData.clause_ID);
                setValues(rowData.comment || "");
                reset({ id: rowData.id, comment: rowData.comment, document_ID: rowData.document_ID, clause_ID: rowData.clause_ID, sub_Clause_ID: rowData.sub_Clause_ID });
            }} />
            <Button icon="pi pi-trash" tooltip="Delete" className="p-button-rounded p-button-text p-button-danger" onClick={() => confirmDelete(rowData)} />
        </div>
    };

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "clause_ID") {
                if (value.clause_ID) {
                    loadSubClausesname(value.clause_ID);
                    setValue("sub_Clause_ID", 0);
                }
            }
        });
        return () => subscription.unsubscribe();
    }, [watch]);

    useEffect(() => {
        if (props.open && props.singleData.document_ID) {
            setValue("document_ID", props.singleData.document_ID);
            loadClauses();
            loadClausesname();
        }
    }, [props.open]);

    return (
        <>
            <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit Clause" modal className="p-fluid" onHide={onHide}>
                <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid mt-3">
                    <JVDropdown required column={2} label="Clause Name" control={control} name="clause_ID" error={errors.clause_ID?.message} options={caluseNameList} optionLabel="clauseName" optionValue="id" placeholder="Select Clause" />
                    <JVDropdown required column={2} label="Sub Clause" control={control} name="sub_Clause_ID" error={errors.sub_Clause_ID?.message} options={subCaluseList} optionLabel="clauseName" optionValue="id" placeholder="Select Sub Clause" />
                    <div className="field col-12 md:col-6">
                        <label>Comment :<span style={{ color: 'red' }}>*</span></label>
                        <InputTextarea autoResize value={values} onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setValues(e.target.value)} rows={5} cols={30} />
                    </div>

                    <div className="field col-12 md:col-3">
                        <label htmlFor="">&nbsp;</label>
                        <Button loading={loading} label="SUBMIT" type="submit"></Button>
                    </div>
                </form>
                <DataTable className="mt-2" style={{ border: '1px solid rgba(105,105,105,0.5)', borderTopWidth: "0" }}
                    size="small" value={calusesList} header="Clause List" showGridlines stripedRows loading={loading1}
                >
                    <Column field="clauseName" header="Clause" />
                    <Column field="subClauseName" header="Sub Clause" />
                    <Column field="comment" header="Comment" body={(rowData) => <p style={{ textOverflow: ((rowData?.comment?.trim().length < 10) ? "" : "ellipsis"), color: ((rowData?.comment?.trim().length < 10) ? "black" : "rgb(13, 137, 236)"), cursor: ((rowData?.comment?.trim().length < 10) ? "text" : "pointer") }} onClick={() => setOpenCommentDialog({ open: true, singleData: rowData })}>{rowData.comment}</p>} />
                    <Column body={actionBodyTemplate} header="Action" headerStyle={{ width: '5%' }} />
                </DataTable>
            </Dialog>
            <Dialog visible={openCommentDialog.open} style={{ width: '40vw' }} header="Comment" modal className="p-fluid" onHide={() => setOpenCommentDialog({ open: false, singleData: {} })}>
                <Card>
                    <p>
                        {openCommentDialog.singleData.comment}
                    </p>
                </Card>
            </Dialog>
            <ConfirmDialog />
        </>
    );
}